import { useEffect } from "react";
import { driveFolderUrl } from "../utils/drive.js";

const COHORT_LABEL = {
  south: "南班",
  north: "北班",
  all: "全班",
};

export default function Detail({ activity, prev, next, onClose, onNav }) {
  // ESC 關閉
  useEffect(() => {
    const h = (e) => { if (e.key === "Escape") onClose(); };
    window.addEventListener("keydown", h);
    return () => window.removeEventListener("keydown", h);
  }, [onClose]);

  const cohortText = activity.cohortBand ? COHORT_LABEL[activity.cohortBand] || activity.cohortBand : null;
  const driveUrl = driveFolderUrl(activity.driveFolderId);

  return (
    <div className="det-overlay">

      {/* ── Top bar ─────────────────────────────── */}
      <div className="det-top">
        <button className="det-back" onClick={onClose}>← Back to Index</button>
        <div className="det-top-actions">
          <div className="det-top-brand">E118</div>
        </div>
      </div>

      <div className="det-container">

        {/* ── Editorial hero（襯線標題）─────────────────────── */}
        <section className="det-hero det-hero-ed">
          <div className="det-hero-meta">
            <span>{activity.dateLong || activity.dateLabel}</span>
            <span className="rule"></span>
            {cohortText && <span>{cohortText}</span>}
          </div>
          <h1>{activity.title}</h1>
          {activity.titleEn && <div className="det-titleEn">{activity.titleEn}</div>}
          {activity.location && <div className="det-loc">{activity.location}</div>}
        </section>

        {/* ── Summary ─────────────────────────────── */}
        <div className="det-body">
          <div className="det-section-label">— Overview</div>
          <div className="det-summary">
            {(activity.summary || "").split(/\n\n+/).map((para, i) => (
              <p key={i}>
                {para.split("\n").map((line, j, arr) => (
                  <span key={j}>
                    {line}
                    {j < arr.length - 1 && <br />}
                  </span>
                ))}
              </p>
            ))}
          </div>
        </div>

        {/* ── 照片：連結導向雲端硬碟（不再站內嵌入相簿）───────── */}
        <section className="det-drive">
          <div className="det-section-label">— Photographs</div>
          <div className="det-drive-actions">
            {activity.detailUrl && (
              <a className="det-drive-btn" href={activity.detailUrl} target="_blank" rel="noopener noreferrer">
                查看完整活動紀錄 →
              </a>
            )}
            {driveUrl && (
              <a className="det-drive-btn det-drive-btn-secondary" href={driveUrl} target="_blank" rel="noopener noreferrer">
                查看活動照片（Google 雲端硬碟）→
              </a>
            )}
          </div>
          {!driveUrl && !activity.detailUrl && (
            <div className="det-gallery-empty">照片連結尚未提供。</div>
          )}
          <p className="det-drive-note">
            照片存放於 Google 雲端硬碟，僅限受邀同學（登入 Google 帳號）檢視。
          </p>
        </section>

        {/* ── Prev / Next ─────────────────────────────── */}
        <nav className="det-nav">
          <button onClick={() => prev && onNav(prev.id)} disabled={!prev}>
            <span className="arrow">← Previous</span>
            <span className="name">{prev ? prev.title : "已是最早"}</span>
          </button>
          <button className="right" onClick={() => next && onNav(next.id)} disabled={!next}>
            <span className="arrow">Next →</span>
            <span className="name">{next ? next.title : "已是最新"}</span>
          </button>
        </nav>

      </div>
    </div>
  );
}
